import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faClock, faCheckCircle, faBoxes, faPercent } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const InquiryOverview = ({ data }) => {
    const { t } = useTranslation();
    if (!data) return null;

    const metrics = [
        {
            label: t('inquiryAnalytics.overview.totalInquiries'),
            value: data.total_inquiries?.toLocaleString('en-IN') ?? '—',
            icon: faClipboardList,
            color: '#0891b2',
            bg: '#ecfeff',
        },
        {
            label: t('inquiryAnalytics.overview.pendingInquiries'),
            value: data.pending_inquiries?.toLocaleString('en-IN') ?? '—',
            icon: faClock,
            color: '#d97706',
            bg: '#fffbeb',
        },
        {
            label: t('inquiryAnalytics.overview.convertedToOrders'),
            value: data.converted_to_orders?.toLocaleString('en-IN') ?? '—',
            icon: faCheckCircle,
            color: '#059669',
            bg: '#ecfdf5',
        },
        {
            label: t('inquiryAnalytics.overview.conversionRate'),
            value: `${parseFloat(data.conversion_rate || 0).toFixed(1)}%`,
            icon: faPercent,
            color: '#7c3aed',
            bg: '#f5f3ff',
        },
        {
            label: t('inquiryAnalytics.overview.totalQuotedQuantity'),
            value: parseFloat(data.total_quoted_quantity || 0).toLocaleString('en-IN', { maximumFractionDigits: 3 }),
            icon: faBoxes,
            color: '#0891b2',
            bg: '#ecfeff',
        },
    ];

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                <div style={{ width: 3, height: 16, borderRadius: 2, backgroundColor: '#0891b2' }} />
                <span style={{ fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.6px' }}>
                    Inquiry Summary
                </span>
            </div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                {metrics.map((m) => (
                    <div
                        key={m.label}
                        style={{
                            flex: '1 1 160px',
                            minWidth: 160,
                            backgroundColor: '#ffffff',
                            border: '1px solid #f3f4f6',
                            borderRadius: 12,
                            padding: '14px 16px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
                        }}
                    >
                        <div style={{ width: 36, height: 36, borderRadius: 10, backgroundColor: m.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: m.color, fontSize: 14, flexShrink: 0 }}>
                            <FontAwesomeIcon icon={m.icon} />
                        </div>
                        <div>
                            <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 600, marginBottom: 2 }}>{m.label}</div>
                            <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', lineHeight: 1 }}>{m.value}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default InquiryOverview;
